import React, { useState } from 'react';
const faqs = [{
  q: 'How do I receive the material?',
  a: 'Instantly via email as downloadable PDFs — straight to your inbox after checkout.'
}, {
  q: 'Do I need to be a qualified rugby coach?',
  a: 'No. The Kit is built for volunteer and grassroots coaches, with clear cues for every drill.'
}, {
  q: 'Is it aligned with RFU coaching standards?',
  a: 'Yes — all session templates and age-grade progressions are fully aligned with current RFU guidance.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-156">
      <div className="max-w-3xl mx-auto" data-id="element-157">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-158">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4 mb-16" data-id="element-159">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(59,130,246,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-160">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-161">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-162">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-163">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-164">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-165">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center relative" data-id="element-166">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full rounded-full pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(16,185,129,0.15) 0%, transparent 70%)'
        }} data-id="element-167"></div>
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-colors inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_0_40px_rgba(22,199,132,0.55)] border border-white/20" data-id="element-168">
            💪 YES! I WANT TO COACH STRESS-FREE NOW
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-169">
            <span data-id="element-170">⚡ Instant Access</span>
            <span data-id="element-171">•</span>
            <span data-id="element-172">🛡️ 7-Day Guarantee</span>
          </p>
        </div>
      </div>
    </section>;
}